import { ApiResult, apiWrapperWithError } from "./ApiUtils";
import type { TemplateSyncGrantResult } from "../../dtos/TemplateSyncGrantResult";
import type { TemplateSyncRunResult } from "../../dtos/TemplateSyncRunResult";
import type { TemplateSyncGrantSelection } from "../../dtos/TemplateSyncGrantSelection";

export const detectOutOfSync = async (moduleId: number): Promise<ApiResult<TemplateSyncGrantResult[]>> => {
    return apiWrapperWithError<TemplateSyncGrantResult[]>(`api/template-sync/detect/${moduleId}`, 'GET', `detecting out-of-sync grants`);
}

export const syncGrants = async (moduleId: number, selections: TemplateSyncGrantSelection[]): Promise<ApiResult<TemplateSyncRunResult>> => {
    return apiWrapperWithError<TemplateSyncRunResult>(`api/template-sync/sync`, 'POST', `syncing grants`, { moduleId, selections });
}
